import { render, staticRenderFns } from "./addNewssss.vue?vue&type=template&id=e45ddbbc&"
import script from "./addNewssss.vue?vue&type=script&lang=js&"
export * from "./addNewssss.vue?vue&type=script&lang=js&"
import style0 from "./addNewssss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports